// main page

import Hero from "@/components/home/hero";
import FeaturedListings from "@/components/home/featured-listings";
import TrustIndicators from "@/components/home/trust-indicators";
import RecentlyViewed from "@/components/home/recently-viewed";

export default function HomePage() {
  return (
    <div className="container mx-auto px-4 space-y-16 py-8">
      <Hero />
      <FeaturedListings />
      <TrustIndicators />
      <RecentlyViewed />
    </div>
  );
}
